/** * * Asynchronously loads the component for
SimService
* */ import { lazyLoad } from "utils/loadable";
export const SimService = lazyLoad(
  () => import("./index"),
  (module) => module.SimService
);
